import * as React from "react";
import * as ReactDom from "react-dom";
import { ICommercetoolsAddress } from "../../ts/models/billing-address";
import { ICommercetoolsCart } from "../../ts/models/icommercetools-cart";
import { GuestRegisterForm } from "./components/guest-register-form";

const ThankyouCartKey = "thankyouCart";

interface IThankyouCart {
	data: ICommercetoolsCart;
}

/**
 * Liest die Bestelldaten der gerade abgeschickten Bestellung aus dem localStorage.
 * Muss synchron und früh erfolgen: Das Tracking-Bundle "thankyou" löscht den Key beim Laden der
 * Danke-Seite (assets/ts/thankyou/components/econda-tracking-order.ts). Dieser Mount hängt im
 * Bundle "tscript", das laut _Layout.cshtml vor "thankyou" eingebunden wird und damit zuerst läuft.
 */
const GetThankyouCart = (): IThankyouCart => {
	try {
		const raw = localStorage.getItem(ThankyouCartKey);
		return raw ? (JSON.parse(raw) as IThankyouCart) : null;
	} catch (err) {
		return null;
	}
};

export const RenderGuestRegisterForm = (): void => {
	const mount: HTMLElement = document.querySelector("#guestRegisterForm");
	if (!mount) {
		return;
	}

	const order = GetThankyouCart();
	const billing: ICommercetoolsAddress =
		order?.data?.Order?.BillingAddress ?? order?.data?.CurrentAddresses?.BillingAddress;

	// Nur für Gastbestellungen: kein Kundenkonto im Warenkorb, aber eine Gast-E-Mail vorhanden.
	// In jedem anderen Fall bleibt der Bereich mit seinem serverseitig gesetzten "hide" stehen.
	if (order?.data?.CustomerId || !billing?.GuestEmailAddress) {
		return;
	}

	const teaser: HTMLElement = document.querySelector("#guestRegisterTeaser");
	if (teaser) {
		teaser.classList.remove("hide");
	}

	ReactDom.render(
		<GuestRegisterForm
			billingAddress={billing}
			siteKey={mount.getAttribute("data-sitekey")}
			successText={mount.getAttribute("data-successtext")}
			myDataUrl={mount.getAttribute("data-mydataurl")}
		/>,
		mount
	);
};
